import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import GLAccountService from "services/lms/glAccount/GlAccountService";

export const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
  showMessage: false,
  count: 0,
  glAccountList: [],
};

const resolveErrorMessage = (payload) => {
  if (!payload) return "Terjadi kesalahan saat memuat GL Account.";
  if (typeof payload === "string") return payload;
  return (
    payload?.message ||
    payload?.Message ||
    payload?.response?.message ||
    "Terjadi kesalahan saat memuat GL Account."
  );
};

const normalizeListResponse = (payload) => {
  if (Array.isArray(payload?.data?.data)) {
    return {
      list: payload.data.data,
      count: payload?.data?.count ?? payload?.count ?? payload.data.data.length,
    };
  }

  if (Array.isArray(payload)) {
    return { list: payload, count: payload.length };
  }

  if (Array.isArray(payload?.data)) {
    return {
      list: payload.data,
      count: payload.count ?? payload.data.length,
    };
  }

  if (Array.isArray(payload?.result)) {
    return {
      list: payload.result,
      count: payload.count ?? payload.result.length,
    };
  }

  if (Array.isArray(payload?.data?.result)) {
    return {
      list: payload.data.result,
      count: payload?.data?.count ?? payload?.count ?? payload.data.result.length,
    };
  }

  return { list: [], count: 0 };
};

export const fetchGLAccounts = createAsyncThunk(
  "GlAccount/fetchGLAccounts",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await GLAccountService.getGLAccounts(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const GlAccountSlice = createSlice({
  name: "GlAccount",
  initialState,
  reducers: {
    resetStates: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      state.showMessage = false;
      state.count = 0;
      state.glAccountList = [];
    },
    clearGlAccountList: (state) => {
      state.glAccountList = [];
      state.count = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGLAccounts.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.showMessage = false;
      })
      .addCase(fetchGLAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        const { list, count } = normalizeListResponse(action.payload);
        state.glAccountList = list;
        state.count = count;
      })
      .addCase(fetchGLAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.showMessage = true;
        state.message = resolveErrorMessage(action.payload);

        notification.error({
          message: "Gagal memuat data GL Account",
          description: resolveErrorMessage(action.payload),
          duration: 5,
        });
      });
  },
});

export const { resetStates, clearGlAccountList } = GlAccountSlice.actions;

export default GlAccountSlice.reducer;
